import _ from 'lodash';
import { getAxiosClient } from '~src/api';

export const fetchProjectFormatsDefault = async () => {
  const httpClient = await getAxiosClient();
  const hasCache = _.has(window.editorConfig, 'defaultFormats.items');

  if (hasCache) {
    return {
      formats: {
        allowNew: false,
        items: window.editorConfig.defaultFormats.items,
      },
    };
  }

  const response = await httpClient.get(
    `${process.env.PARSE_API_URL}/editor_project_formats_default`
  );
  const items = response.data.data;
  return {
    formats: {
      allowNew: false,
      items,
    },
  };
};
